import React, { useEffect, useState } from "react";
import VendaDetalhamento from "../../../components/vendas/detalhamento";
import VendasPorDiasDaSemana from "../../../components/vendas/dias-semana";
import functions from "../../../util/functions";
import FilterModal from "../../../components/filter/Modal";
import Notification from "../../../components/toast";
import { ToastContainer } from "react-toastify";
import reqVenda from "../../../services/reqMultiTenant/reqVenda";
import HeaderReport from "../../../components/header/report";
import HeaderListFilter from "../../../components/header/report-filter";

function RelatorioVendasDetalhamento() {
	const [listVendasPorDia, setListVendasPorDia] = useState([]);
	const [listVendasComparativoMesComMesAnterior, setListVendasComparativoMesComMesAnterior] = useState([]);

	const [isFilterOpen, setIsFilterOpen] = useState(false);
	const [onloading, setOnLoading] = useState(false);
	const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
	const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

	useEffect(() => {
		ListarVendas();
	}, []);

	const ListarVendas = () => {
		setIsFilterOpen(false);

		const isCurrentMonth =
			parseInt(selectedMonth) === new Date().getMonth() + 1 &&
			parseInt(selectedYear) === new Date().getFullYear();

		let referenceDate;
		if (isCurrentMonth) {
			referenceDate = new Date();
		} else {
			referenceDate = new Date(selectedYear, selectedMonth, 0); // Último dia do mês selecionado
		}

		const dataIni = functions.dateByString(functions.dateToStrIso(new Date(selectedYear, selectedMonth - 1, 1)));
		const dataFim = functions.dateByString(functions.dateToStrIso(new Date(selectedYear, selectedMonth, 0)));
		const referenceDateStr = functions.dateByString(functions.dateToStrIso(referenceDate));

		list(dataIni, dataFim, referenceDateStr);
	};

	const list = async (dataIni, dataFim, referenceDate) => {
		try {
			setOnLoading(true);
			const [responseVendasPorDia, responseVendasPorMes] = await Promise.all([
				reqVenda.listByDay(dataIni, dataFim),
				reqVenda.listByMonth(referenceDate),
			]);

			setListVendasPorDia(responseVendasPorDia.data);
			if (responseVendasPorMes) setListVendasComparativoMesComMesAnterior(responseVendasPorMes.data);
		} catch (error) {
			Notification.showToast({ message: error.message, type: "warning" });
		} finally {
			setOnLoading(false);
		}
	};

	function openFilter() {
		setIsFilterOpen(!isFilterOpen);
	}

	function closeFilter() {
		setIsFilterOpen(false);
	}

	return (
		<>
			<div className="container mt-page">
				<ToastContainer />
				<FilterModal //
					title={"Relatório de Vendas (Detalhado)"}
					isOpen={isFilterOpen}
					onRequestClose={closeFilter}
					monthYear={true}
					selectedMonth={selectedMonth}
					setSelectedMonth={setSelectedMonth}
					selectedYear={selectedYear}
					setSelectedYear={setSelectedYear}
					handleList={ListarVendas}
				/>

				{/* HEADER PADRONIZADO */}
				<header className="flex flex-col bg-white p-2 rounded-sm box-shadow-md mb-6">
					<div className="grid grid-cols-2">
						<div className="col-span-1">
							<HeaderReport title="Detalhamento por período" subTitle="Detalhes das vendas" />
						</div>
						<div className="col-span-1 flex justify-end mb-2">
							<div className="flex flex-col gap-1">
								<HeaderListFilter
									filterData={{
										periodo: {
											label: "Período",
											value: `${selectedMonth}/${selectedYear}`,
										},
									}}
								/>
							</div>
						</div>
					</div>

					<div className="col-span-1 flex justify-end items-end mt-2">
						<div className="flex gap-2 h-8">
							<button className="btn btn-sm btn-primary w-32" onClick={openFilter}>
								Filtrar
							</button>
						</div>
					</div>
					<div className="border-bottom mt-3"></div>
				</header>

				{onloading ? (
					<div className="text-center mt-5">
						<span>Buscando Dados...</span>
					</div>
				) : listVendasPorDia.length > 0 ? (
					<>
						<VendaDetalhamento
							listVendasPorDia={listVendasPorDia}
							listComparativo={listVendasComparativoMesComMesAnterior}
						/>

						{/* Divisor visual entre os dois componentes */}
						<div className="flex items-center gap-3 mt-8 mb-2">
							<div className="flex-1 border-t border-slate-200" />
							<span className="text-xs text-slate-400 uppercase tracking-widest whitespace-nowrap">
								Vendas por Dia da Semana
							</span>
							<div className="flex-1 border-t border-slate-200" />
						</div>

						<VendasPorDiasDaSemana listVendasPorDia={listVendasPorDia} />
					</>
				) : (
					<p className="text-sm text-slate-400 text-center mt-6 mb-2">Nenhum registro encontrado.</p>
				)}
			</div>
		</>
	);
}

export default RelatorioVendasDetalhamento;
